export default __webpack_public_path__ + "static/media/CityscapeLogo.a61914e9.png";